import {
  PaginationState, createColumnHelper, flexRender,
  getCoreRowModel, getExpandedRowModel, getSortedRowModel, useReactTable,
} from "@tanstack/react-table";
import DivLoader from "components/divloader/DivLoader";
import React, { useState, useEffect, useContext } from "react";
import { PaymentRowObj } from "..";
import InfoModal from "./InfoModalNew";
import { convertToFloat } from "utils/formatNumber";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { ClientContext } from "ClientProvider";
import { DownloadCSV } from "api/payouts";
import { toast } from "react-hot-toast";
import ShortTruncateCopy from "components/common/ShortTruncateCopy";
import Searchbox from "components/fields/Searchbox";
import { getImage } from "utils/commonFunction";
import Pagination from "components/pagination";
import StatusRender from "./StatusRender";
import CustomToolTip from "components/tooltips/new";
import { RiArrowUpDownFill } from "react-icons/ri";
import Card from "components/card";

const columnHelper = createColumnHelper<PaymentRowObj>();

function PaymentTable(props: {
  tableData: any; fetchPayments: () => void; filterData: () => void;
  isLoading: boolean; page: number; setPage: any; totalpage: number;
  totalItems: number; currentPage: number; clients: any[]; allGateways: any[];
  allCardType: any[]; curretClient: string; setCurrentClient: any;
  pageSize: number; setPageSize: any; roleData: any; filter: any;
  setFilter: (e: any) => void; onValueChange: (value: string) => void;
  setLocalFilters?: (e: any) => void; setClearClick: () => void;
}) {
  const {
    tableData, page, allGateways, setPage, currentPage, totalpage,
    pageSize, setPageSize, roleData, filter, onValueChange,totalItems
  } = props;

  const [{ pageIndex }, setPagination] = React.useState<PaginationState>({ pageIndex: 0, pageSize });
  const { paymentGateway, paymentType, singleRoleData } = useContext(ClientContext);
  const [DownloadLoading, setDownloadLoading] = useState(false);
  const [data, setData] = React.useState(() => [...(tableData ?? [])]);
  const pagination = React.useMemo(() => ({ pageIndex, pageSize }), [pageIndex, pageSize]);
  const method = roleData[0]?.crypto?.value?.show_crypto_payout_gateway_name;

  React.useEffect(() => { setData(tableData ?? []); }, [tableData]);

  const buildColumns = (withAction: boolean) => [
    columnHelper.accessor("client_name", {
      id: "client",
      header: () => <span className="cp-th">Client</span>,
      cell: (info: any) => !info.row.getIsExpanded() ? (
        <div className="cp-client-cell">
          <div className="cp-client-avatar">{info.getValue()?.charAt(0)?.toUpperCase() || "?"}</div>
          <span className="cp-client-name">{info.getValue()}</span>
        </div>
      ) : null,
    }),
    columnHelper.accessor("created_at", {
      id: "created_at",
      header: () => <span className="cp-th">Date</span>,
      sortDescFirst: true,
      cell: (info) => !info.row.getIsExpanded() ? <span className="cp-date">{info.getValue()}</span> : null,
    }),
    columnHelper.accessor("crypto_amount", {
      id: "crypto_amount",
      header: () => <span className="cp-th">Amount</span>,
      cell: (info: any) => !info.row.getIsExpanded() ? (
        <span className="cp-amount">{convertToFloat(info.getValue())} {info?.row?.original?.crypto_currency}</span>
      ) : null,
    }),
    columnHelper.accessor("et_id", {
      id: "et_id_",
      header: () => <span className="cp-th">Transaction ID</span>,
      cell: (info) => !info.row.getIsExpanded() ? <ShortTruncateCopy info={info?.getValue()} showCopy /> : null,
    }),
    columnHelper.accessor("id", {
      id: "id",
      header: () => <span className="cp-th">Internal ID</span>,
      cell: (info: any) => !info.row.getIsExpanded() ? <ShortTruncateCopy info={info?.getValue()} showCopy /> : null,
    }),
    columnHelper.accessor("gateway_id", {
      id: "gateway_id",
      header: () => <span className="cp-th">Gateway {method ? "Name" : "Hash ID"}</span>,
      cell: (info) => !info.row.getIsExpanded() ? (
        !singleRoleData[0]?.crypto?.value?.show_crypto_payout_gateway_name
          ? <ShortTruncateCopy info={info?.cell?.row?.original?.gateway_id || "—"} showCopy />
          : <div className="cp-gateway-cell">
              <img style={{ height:"auto", width:"14px" }} src={getImage(info?.cell?.row?.original?.gateway_name)} alt="" />
              <span className="cp-gateway-name">{info?.cell?.row?.original?.gateway_name || "—"}</span>
            </div>
      ) : null,
      enableSorting: true, sortingFn: "alphanumeric",
    }),
    columnHelper.accessor("meta_info.Descriptor" as any, {
      id: "descriptor",
      header: () => <span className="cp-th">Descriptor</span>,
      cell: (info: any) => !info.row.getIsExpanded() ? <span className="cp-descriptor">{info.row.original.meta_info?.Descriptor || "—"}</span> : null,
      sortingFn: "alphanumeric", enableSorting: true,
    }),
    columnHelper.accessor("status", {
      id: "status",
      header: () => <span className="cp-th">Status</span>,
      cell: (info) => !info.row.getIsExpanded() ? (
        <CustomToolTip
          content={info?.row?.original?.payment_history?.length > 0
            ? info?.row?.original?.payment_history?.map((h: any, i: number) => (
                <Card className="m-2 shadow" key={i}>
                  <div className="border border-white p-3 max-w-[60vh]">
                    <p>{i === 0 ? `Created at ${h?.created_at} by API call from [${h?.client} - ${h?.ip}] with status ${h?.status}` : `Status change from ${h?.previous_status} to ${h?.status} at ${h?.status_changed_date}`}</p>
                  </div>
                </Card>
              ))
            : <span>No history available.</span>
          }
          trigger={<button className="cp-status-btn"><StatusRender status={info?.row?.original?.status} value={info.getValue()} /></button>}
          header="Status History"
        />
      ) : null,
    }),
    ...(withAction ? [columnHelper.accessor("et_id", {
      id: "et_id",
      header: () => <span className="cp-th">Actions</span>,
      cell: (info: any) => !info.row.getIsExpanded() ? (
        <div className="cp-actions">
          {roleData?.[0]?.crypto?.value?.view_crypto_payout_response_information && <InfoModal info={info.row.original} />}
        </div>
      ) : null,
      enableSorting: false,
    })] : []),
  ];

  const table = useReactTable({
    data,
    columns: roleData?.[0]?.crypto?.value?.view_crypto_payout_response_information ? buildColumns(true) : buildColumns(false),
    state: { pagination },
    onPaginationChange: setPagination,
    getSubRows: (row) => row.all_data,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
  });

  return (
    <div className="cp-table-card">
      <div className="cp-table-header">
        <div className="cp-table-header-left">
          <div className="cp-table-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>
          <div>
            <h3 className="cp-table-title">Single Crypto Payouts</h3>
            {/* <p className="cp-table-sub">Individual cryptocurrency payout transactions</p> */}
            <p className="cp-table-sub">{totalItems > 0 ? `${totalItems.toLocaleString()} total transaction${totalItems !== 1 ? "s" : ""}` : "No transactions"}</p>

          </div>
        </div>
        <div className="cp-table-header-right">
          <Searchbox onSearch={(e) => onValueChange(e)} />
        </div>
      </div>

      <div className="cp-table-wrap">
        {props.isLoading ? (
          <div className="cp-loading"><div className="cp-spinner" /><p className="cp-loading-txt">Loading payouts…</p></div>
        ) : (
          <table className="cp-table">
            <thead>
              {table.getHeaderGroups().map((hg) => (
                <tr key={hg.id}>
                  {hg.headers.map((h) => (
                    <th key={h.id} colSpan={h.colSpan}
                      onClick={h.column.getToggleSortingHandler()}
                      className={`cp-thead-th${h.column.getCanSort() ? " cp-thead-th--sort" : ""}`}
                    >
                      <div className="cp-th-inner">
                        {flexRender(h.column.columnDef.header, h.getContext())}
                        {h.column.getCanSort() && (
                          <span className="cp-sort-icon">
                            {h.column.getIsSorted() === "asc" ? <BsArrowUp size={11} /> :
                             h.column.getIsSorted() === "desc" ? <BsArrowDown size={11} /> :
                             <RiArrowUpDownFill size={11} />}
                          </span>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map((row, ri) => (
                  <tr key={row.id} className={`cp-tbody-tr${ri % 2 !== 0 ? " cp-tbody-tr--alt" : ""}`}>
                    {row.getVisibleCells().map((cell, ci) => (
                      <td key={ci} className="cp-tbody-td">{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr><td colSpan={10}>
                  <div className="cp-empty">
                    <div className="cp-empty-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/></svg></div>
                    <p className="cp-empty-title">No payouts found</p>
                    <p className="cp-empty-sub">Try adjusting your filters</p>
                  </div>
                </td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      <div className="cp-pagination-wrap">
        <Pagination setPage={setPage} page={page} totalpage={totalpage} currentPage={currentPage} pageSize={pageSize} setPageSize={setPageSize} arraySize={[50, 100, 200]} />
      </div>

      {CP_TABLE_STYLES}
    </div>
  );
}

export default PaymentTable;

export const CP_TABLE_STYLES = (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
    .cp-table-card { font-family:'Plus Jakarta Sans',sans-serif; background:#fff; border:1px solid #e2e8f0; border-radius:18px; overflow:hidden; box-shadow:0 2px 8px rgba(15,23,42,.06); }
    .cp-table-header { padding:15px 20px 12px; border-bottom:1px solid #f1f5f9; display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; }
    .cp-table-header-left { display:flex; align-items:center; gap:10px; }
    .cp-table-icon { width:36px; height:36px; border-radius:10px; background:linear-gradient(135deg,#faf5ff,#ede9fe); border:1.5px solid #ddd6fe; display:flex; align-items:center; justify-content:center; color:#7c3aed; flex-shrink:0; }
    .cp-table-title { font-size:14px; font-weight:700; color:#0f172a; letter-spacing:-.2px; margin-bottom:1px; line-height:20px; }
    .cp-table-sub { font-size:11.5px; color:#94a3b8; font-weight:500; }
    .cp-table-header-right { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
    .cp-table-wrap { overflow-x:auto; }
    .cp-table-wrap::-webkit-scrollbar { height:3px; }
    .cp-table-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }
    .cp-table { width:100%; border-collapse:collapse; }
    .cp-thead-th { padding:9px 12px 8px; background:#f8fafc; border-bottom:1.5px solid #e2e8f0; text-align:left; white-space:nowrap; user-select:none; }
    .cp-thead-th--sort { cursor:pointer; }
    .cp-thead-th--sort:hover { background:#f1f5f9; }
    .cp-th-inner { display:flex; align-items:center; gap:4px; }
    .cp-th { font-size:10.5px; font-weight:700; color:#374151; text-transform:uppercase; letter-spacing:.4px; }
    .cp-sort-icon { color:#b0bec5; display:flex; align-items:center; flex-shrink:0; }
    .cp-tbody-tr { transition:background .1s; }
    .cp-tbody-tr:hover { background:#faf5ff; }
    .cp-tbody-tr--alt { background:#fafbfc; }
    .cp-tbody-tr--alt:hover { background:#f3f0ff; }
    .cp-tbody-td { padding:8px 12px; border-bottom:1px solid #f1f5f9; vertical-align:middle; }
    .cp-client-cell { display:flex; align-items:center; gap:6px; }
    .cp-client-avatar { width:24px; height:24px; border-radius:6px; background:linear-gradient(135deg,#faf5ff,#ede9fe); border:1.5px solid #ddd6fe; display:flex; align-items:center; justify-content:center; font-size:9.5px; font-weight:800; color:#7c3aed; flex-shrink:0; }
    .cp-client-name { font-size:12px; font-weight:600; color:#0f172a; white-space:nowrap; }
    .cp-date { font-size:11.5px; font-weight:500; color:#334155; white-space:nowrap; }
    .cp-amount { font-size:12.5px; font-weight:700; color:#0f172a; white-space:nowrap; text-transform:uppercase; }
    .cp-gateway-cell { display:flex; align-items:center; gap:6px; }
    .cp-gateway-name { font-size:12px; font-weight:600; color:#0f172a; white-space:nowrap; }
    .cp-descriptor { font-size:12px; font-weight:500; color:#475569; white-space:nowrap; }
    .cp-status-btn { background:none; border:none; cursor:pointer; padding:0; display:inline-flex; align-items:center; }
    .cp-actions { display:flex; align-items:center; gap:4px; }
    .cp-loading { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px; gap:12px; }
    .cp-spinner { width:26px; height:26px; border:3px solid #e2e8f0; border-top-color:#7c3aed; border-radius:50%; animation:cpSpin .7s linear infinite; }
    @keyframes cpSpin { to{transform:rotate(360deg)} }
    .cp-loading-txt { font-size:12.5px; color:#94a3b8; font-weight:500; }
    .cp-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px 24px; gap:10px; }
    .cp-empty-icon { width:48px; height:48px; border-radius:12px; background:#f8fafc; border:1.5px solid #e2e8f0; display:flex; align-items:center; justify-content:center; color:#cbd5e1; }
    .cp-empty-title { font-size:13.5px; font-weight:700; color:#64748b; }
    .cp-empty-sub { font-size:12px; color:#94a3b8; font-weight:500; text-align:center; }
    .cp-pagination-wrap { padding:10px 14px; border-top:1px solid #f1f5f9; background:#fafbfc; }
    @media (max-width:700px) { .cp-table-header { flex-direction:column; align-items:flex-start; } .cp-table-header-right { width:100%; } }
  `}</style>
);